export default __webpack_public_path__ + "media/Veggies-Mushroom.32e15869.png";